import React, { useState, useContext, Fragment, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { Context } from './Context'
import { MainData } from '../wbstdt/Wbstdt'
import Nav from './Nav'
import Footer from './Footer'
import RequestCat from './RequestCat'

export default function Home() {

    const { lang } = useContext(Context)
    const [reqCatBool, setReqCatBool] = useState(false)

    useEffect(() => {
        document.body.scrollTop = 0
        document.documentElement.scrollTop = 0
    }, [])

    const hideCatForm = () => {
        setReqCatBool(false)
    }

    return (
        <Fragment>
            {reqCatBool && <RequestCat onClick={hideCatForm} />}
            <div>
                <Nav />
                <section id="hp-section-1" className="container box-wsp-outline">
                    <div className="container flex-container-centered">
                        <div className="flex-item">
                            <h2 className="title title-bullet">{MainData[lang].s1.title}</h2>
                            <div className="flex-item mob">
                                <img src={MainData[lang].s1.img} alt="Hero-1" />
                            </div>
                            <p className="box-wsp">{MainData[lang].s1.desc}</p>
                            <button className="btn btn-small btn-gst" onClick={() => setReqCatBool(true)}>{MainData[lang].s1.btn}</button>
                        </div>
                        <div className="flex-item desk">
                            <img src={MainData[lang].s1.img} alt="Hero-1" />
                        </div>
                    </div>
                </section>
                <section id="hp-section-2" className="container box-wsp-outline">
                    <h4 className="title flex-container-centered">{MainData[lang].off_s1.title}</h4>
                    <div className="flex-container-scattered container">
                        {MainData[lang].off_s1.imgs.map((item, index) => {
                            return (
                                <div key={index} style={{ backgroundImage: `url(${item})` }} className="bg-img contained-bg flex-item"></div>
                            )
                        })}
                    </div>
                </section>
                <section id="hp-section-3" className="container box-wsp-outline">
                    <div className="container flex-container-centered">
                        <div className="flex-item desk">
                            <img src={MainData[lang].s2.img} alt="Hero-2" />
                        </div>
                        <div className="flex-item">
                            <h2 className="title title-bullet">{MainData[lang].s2.title}</h2>
                            <div className="flex-item box-wsp mob">
                                <img src={MainData[lang].s2.img} alt="Hero-2" />
                            </div>
                            <p className="box-wsp-outline">{MainData[lang].s2.desc}</p>
                        </div>
                    </div>
                </section>
                <section id="hp-section-4" className="box-wsp">
                    <div className="flex-container-centered">
                        <h2 className="title title-bullet box-wsp">{MainData[lang].s3.title}</h2>
                    </div>
                    <div className="container flex-container-scattered box-wsp cards">
                        {MainData[lang].s3.cards.map((item, index) => {
                            return (
                                <div key={index} className="card flex-container-centered">
                                    <div>
                                        <h3 className="title">{item.title}</h3>
                                    </div>
                                    <div className="bg-img contained-bg" style={{ backgroundImage: `url(${item.img})` }}></div>
                                    <div>
                                        <p>{item.desc}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </section>
                <section id="hp-section-5" className="box-wsp box-wsp-outline">
                    <div className="flex-container-centered box-wsp">
                        <img className="box-wsp mob-img" src={MainData[lang].s4.logo} alt="Lami-Guard-Logo" />
                    </div>
                    <div className="container flex-container-centered desc">
                        <p>{MainData[lang].s4.desc}</p>
                    </div>
                    <div className="flex-container-centered mob">
                        <img className="mob-img" src={MainData[lang].s4.img} alt="Lami-Demo" />
                    </div>
                    <div className="container flex-container-centered lami-demo">
                        <div className="flex-container-centered">
                            <div className="flex-container-centered">
                                <img src={MainData[lang].s4.cards[0].img} alt="" />
                                <p>{MainData[lang].s4.cards[0].title}</p>
                            </div>
                            <div className="flex-container-centered">
                                <img src={MainData[lang].s4.cards[1].img} alt="" />
                                <p>{MainData[lang].s4.cards[1].title}</p>
                            </div>
                        </div>
                        <div className="flex-container-centered desk lami-main-img" data-p1={MainData[lang].s4.detail_1} data-p2={MainData[lang].s4.detail_2}>
                            <img src={MainData[lang].s4.img} alt="Lami-Demo" />
                        </div>
                        <div className="flex-container-centered">
                            <div className="flex-container-centered">
                                <img src={MainData[lang].s4.cards[2].img} alt="" />
                                <p>{MainData[lang].s4.cards[2].title}</p>
                            </div>
                            <div className="flex-container-centered">
                                <img src={MainData[lang].s4.cards[3].img} alt="" />
                                <p>{MainData[lang].s4.cards[3].title}</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section id="hp-section-6" className="container box-wsp">
                    {MainData[lang].s5.map((item, index) => {
                        return (
                            <div key={index} className={index === 1 ? "box-wsp-outline" : ""}>
                                <div className="flex-container-centered">
                                    <h2 className="title title-bullet">{item.title}</h2>
                                </div>
                                <div className="cards container">
                                    {item.cards.map((item_2, index_2) => {
                                        return (
                                            <div key={index_2} className="flex-container-scattered box-wsp card flex-col ">
                                                <div className="bg-img contained-bg" style={{ backgroundImage: `url(${item_2.img})` }}>
                                                </div>
                                                <div className="desc box-wsp">
                                                    <h3 className="title">{item_2.title}</h3>
                                                    <p>{item_2.desc}</p>                                            </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </section>
                <section id="hp-section-7" className="container box-wsp-outline">
                    <h4 className="title flex-container-centered">{MainData[lang].off_s2.title}</h4>
                    <div className="flex-container-scattered container">
                        {MainData[lang].off_s2.imgs.map((item, index) => {
                            return (
                                <div key={index} style={{ backgroundImage: `url(${item})` }} className="bg-img contained-bg flex-item"></div>
                            )
                        })}
                    </div>
                </section>
                <section id="hp-section-8" className="container box-wsp-outline">
                    <div className="container flex-container-centered">
                        <div style={{ width: '50rem' }}>
                            <div className="container flex-container-centered">
                                <h2 style={{ textAlign: 'center' }} className="title title-bullet">{MainData[lang].s6.title}</h2>
                            </div>
                            <div style={{ width: '20rem' }} className="mob">
                                <img style={{ width: '100%' }} src={MainData[lang].s6.img} alt="Catalogue" />
                            </div>
                            <div className="container flex-container-centered">
                                <p className="">{MainData[lang].s6.desc}</p>
                            </div>
                            <div className="container flex-container-centered box-wsp">
                                <Link to="/devis"> <button className="btn btn-small btn-gst">{MainData[lang].s6.btn}</button>
                                </Link>
                            </div>
                        </div>
                        <div style={{ width: '40rem' }} className="desk">
                            <img style={{ width: '100%' }} src={MainData[lang].s6.img} alt="Catalogue" />
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/Component/Home.js